import type { Scene } from "@core/scene-manager";

export interface MenuSceneDeps {
  element: HTMLElement;
  buttons: { play: HTMLButtonElement; settings: HTMLButtonElement; credits: HTMLButtonElement };
  onPlay: () => Promise<void> | void;
  onSettings?: () => Promise<void> | void;
  onCredits?: () => Promise<void> | void;
}

/** Сцена главного меню. */
export class MenuScene implements Scene {
  readonly id = "menu" as const;
  private cleanups: (() => void)[] = [];

  constructor(private readonly deps: MenuSceneDeps) {}

  /** Показывает меню и навешивает обработчики кнопок. */
  onEnter(): void {
    this.deps.element.classList.add("is-visible");
    this.deps.element.setAttribute("aria-hidden", "false");

    const bind = (btn: HTMLButtonElement, fn?: () => Promise<void> | void): void => {
      if (!fn) return;
      const handler = () => {
        void fn();
      };
      btn.addEventListener("click", handler);
      this.cleanups.push(() => btn.removeEventListener("click", handler));
    };

    bind(this.deps.buttons.play, this.deps.onPlay);
    bind(this.deps.buttons.settings, this.deps.onSettings);
    bind(this.deps.buttons.credits, this.deps.onCredits);
  }

  /** Скрывает меню и удаляет обработчики. */
  onExit(): void {
    for (const c of this.cleanups) c();
    this.cleanups = [];
    this.deps.element.classList.remove("is-visible");
    this.deps.element.setAttribute("aria-hidden", "true");
  }
}
